import React from "react";

export default function Spinner() {
  return <div>Loading...</div>;
}
